module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-rp.82833ad2.png";